import styled from 'styled-components'

export const InputWrapper = styled.div`
  display: flex;
  align-items: start;
  gap: 16px;
  padding: 16px 0;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  margin-bottom: 24px;
`
export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  svg {
    &:hover {
      cursor: pointer;
    }
  }
  h2 {
    font-size: 18px;
    color: var(--gray-2);
    font-weight: 600;
  }
`

export const ModalBody = styled.div`
  font-size: 14px;
  color: var(--gray-5);
  text-align: start;
  padding: 0 8px;
  margin-bottom: 8px;
  max-height: 400px;
  max-width: 382px;
  overflow: auto;
  strong {
    font-weight: 600;
  }

  .specificConditions {
    font-size:12px;
    padding-top: 2px;
  }

`
